<template>
    <div class="row">
      <div class="col-md-6">
        <div class="fm-input-group">
          <div class="row">
            <div class="col-md-12 fm-input-group__title fme-montserrat-font">
              <h5>{{ inputOneTitle }}</h5>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <input v-model="inputOneValue" :type="inputOneType" :id="inputOneId" :placeholder="inputOnePlaceholder" @change="returnInputValue"  :class="[  inputErrorText !== '' ? 'inputError' : '', inputOneCss ]" :disabled="inputDisabled"  >
      <p v-if="inputErrorText !== ''">{{ inputErrorText }}</p>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12 fm-input-group__error-msg fme-hind-font">
              <p v-if="inputErrorText !== ''">{{ inputErrorText }}</p>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-6">
        <div class="fm-input-group">
          <div class="row">
            <div class="col-md-12 fm-input-group__title fme-montserrat-font">
              <h5>{{ inputTwoTitle }}</h5>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <input v-model="inputTwoValue" :type="inputTwoType" :id="inputTwoId" :placeholder="inputTwoPlaceholder" @change="returnInputValue"  :class="[  inputErrorText !== '' ? 'inputError' : '', inputTwoCss ]" :disabled="inputDisabled"  >
      <p v-if="inputErrorText !== ''">{{ inputErrorText }}</p>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12 fm-input-group__error-msg fme-hind-font">
              <p v-if="inputErrorText !== ''">{{ inputErrorText }}</p>
            </div>
          </div>
        </div>

      </div>
    </div>
</template>

<script>
export default {
  name: 'DoubleInput',
  data () {
    return {
      inputOneValue: '',
      inputTwoValue: ''
    }
  },
  props: {
    inputOneTitle: {
      type: String,
      default: 'Title'
    },
    inputTwoTitle: {
      type: String,
      default: 'Title'
    },
    inputOnePlaceholder: {
      type: String,
      default: 'Insert a text'
    },
    inputTwoPlaceholder: {
      type: String,
      default: 'Insert a text'
    },
    inputOneId: {
      type: String,
      required: true
    },
    inputTwoId: {
      type: String,
      required: true
    },
    inputOneCss: {
      type: String,
      default: ''
    },
    inputTwoCss: {
      type: String,
      default: ''
    },
    inputOneType: {
      type: String,
      validator: function (value) {
        return ['button', 'checkbox', 'color', 'date', 'datetime-local', 'email', 'file', 'hidden', 'image', 'month', 'number', 'password', 'radio', 'range', 'reset', 'search', 'submit', 'tel', 'text', 'time', 'url', 'week'].indexOf(value) !== -1
      }
    },
    inputTwoType: {
      type: String,
      validator: function (value) {
        return ['button', 'checkbox', 'color', 'date', 'datetime-local', 'email', 'file', 'hidden', 'image', 'month', 'number', 'password', 'radio', 'range', 'reset', 'search', 'submit', 'tel', 'text', 'time', 'url', 'week'].indexOf(value) !== -1
      }
    },
    inputOneCurrentValue: {
      type: [String, Array, Object],
      default: ''
    },
    inputTwoCurrentValue: {
      type: [String, Array, Object],
      default: ''
    },
    inputErrorText: {
      type: String,
      default: ''
    },
    inputClear: {
      type: Boolean,
      default: false,
      validator: function (value) {
        return [true, false].indexOf(value) !== -1
      }
    },    
    inputDisabled: {
      type: Boolean,
      default: false,
      validator: function (value) {
        return [true, false].indexOf(value) !== -1
      }
    },
  },
  components: {
  },
  computed: {
  },
  methods: {
    returnInputValue () {
      if (this.inputOneValue !== '' && this.inputTwoValue !== '') {
        let newReturnValue = {
          'one': this.inputOneValue,
          'two': this.inputTwoValue
        }
        this.$emit('returned-double-input-value', newReturnValue)
        if (this.inputClear === true) {
          this.inputOneValue = ''
          this.inputTwoValue = ''
        }
      }
    }
  },
  filters: {
  },
  watch: {
    inputOneCurrentValue (newValue, oldValue) {
      this.inputOneValue = newValue
    },
    inputTwoCurrentValue (newValue, oldValue) {
      this.inputTwoValue = newValue
    }
  }
}
</script>

<style lang="scss">
.fm-input-group {
  .fm-input-group__title {
    h5 {
      font-size: 20px;
      font-weight: 500;
      padding-left: 12px;
    }
  }
  input {
    width: 100%;
    height: 50px;
    max-height: 50;
    padding-right: 20px;
    padding-left: 20px;
    border-radius: 5px;
    display: inline-block;
    border:1px solid $fme-color__old-silver;
    overflow: visible;
    color: $fme-color__old-silver;
    &::placeholder {
      font-size: 18px;
      font-family: 'Hind', sans-serif;
    }
    &.inputError {
      border:1px solid $fme-color__rosso-corsa;
    }
  }
  .fm-input-group__error-msg {
    font-size: 14px;
    font-weight: 400;
    padding-left: 30px;
    padding-top: 2px;
    color: $fme-color__rosso-corsa;
  }
}
</style>
